import Swal from "sweetalert2";

export default function ConfirmarEtapaButton({
  podeConfirmar,
  onConfirmar,
  disabled = false,
}) {
  if (!podeConfirmar) return null;

  const handleClick = async () => {
    const result = await Swal.fire({
      title: "Confirmação",
      text: "Deseja realmente confirmar os documentos desta etapa?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--accent)",
      cancelButtonColor: "var(--danger)",
      confirmButtonText: "Sim, confirmar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    try {
      await onConfirmar();

      await Swal.fire({
        title: "Sucesso!",
        text: "Documentos confirmados com sucesso!",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Erro ao confirmar documentos:", error);

      await Swal.fire({
        title: "Erro!",
        text: "Ocorreu um problema ao confirmar os documentos.",
        icon: "error",
      });
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      style={{
        marginTop: 16,
        padding: "8px 14px",
        backgroundColor: "var(--accent)",
        color: "var(--text-primary)",
        borderRadius: 4,
        border: "none",
        cursor: "pointer",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      Confirmar documentos
    </button>
  );
}